module.exports = __webpack_public_path__ + "static/media/icon-estoque.82f09648.svg";